// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2SqvZ","row":"styles_row__1xx7H"};